/**
 * Messages FR pour la gestion de FullCalendar
 */

module.exports = {

    day: 'Day',
    month: 'Month',
    week: 'Week',
    today: 'Today',

    weekShort: 'W',

    countEvents: 'No event | 1 more event | { count } more events'

};
